import { Component, OnDestroy, OnInit } from "@angular/core";
import { AzureSuggestsResult } from "../../../azure-search/models/azure-suggests-result.model";
import { SearchRequest, SearchResultsService } from "../../../search-results/search-results";
import { Location, LogService, MarketTrackingEvents } from "../../../core/core";
import { GeolocationService } from "../../../core/services/geolocation.service";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { commerceSearchIntent, searchDestination } from "../../../search-results/models/commerce-search-intent";

@Component({
  selector: "app-header-search",
  templateUrl: "./header-search.component.html",
  styleUrls: ["./header-search.component.scss"],
})
export class HeaderSearchComponent implements OnInit, OnDestroy {
  searchRequest: SearchRequest;
  sub: Subscription;

  constructor(
    private router: Router,
    private searchResultsService: SearchResultsService,
    private logService: LogService,
    private geolocationService: GeolocationService,
  ) {}

  ngOnInit() {
    this.searchRequest = this.searchResultsService.searchRequest;
    this.sub = this.searchResultsService.searchRequest$.subscribe(searchRequest => {
      this.searchRequest = searchRequest == null ? new SearchRequest() : searchRequest;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  suggestionSelected($event: AzureSuggestsResult) {
    this.searchRequest.searchTerm = $event.value;
    this.searchRequest.selectedSuggestion = $event;

    this.onEnter();
  }

  locationSelected(event: Location) {
    this.searchRequest.location.location = event;
    // store this so we can look up gps coordinates
    this.searchResultsService.storeLocation(event);

    this.onEnter();
  }

  useMyLocation() {
    this.geolocationService.getCurrentLocation().subscribe(location => {
      this.searchRequest.location.location = location;
      this.onEnter();
    });
  }

  onEnter() {
    const suggestion = this.searchRequest.selectedSuggestion;
    const intent = suggestion?.searchTarget
      ? { target: suggestion.searchTarget, query: suggestion.searchQuery ?? "" }
      : commerceSearchIntent(this.searchRequest.searchTerm || "");
    if (intent?.target === "attachments" || intent?.target === "parts") {
      const destination = searchDestination(intent.target, intent.query);
      this.router.navigate([destination.path], { queryParams: destination.queryParams });
      return;
    }
    let queryParams = this.searchRequest.queryParams;
    queryParams["q"] = this.searchRequest.searchTerm;
    this.router.navigate([this.searchRequest.searchResultsUrl()], {
      queryParams,
    });

    this.logService.trackEvent(
      MarketTrackingEvents.Search.Header,
      {
        event: "rentalSearch",
        searchTerm: this.searchRequest.searchTerm,
        location: this.searchRequest.location.toCityState(),
      },
      true,
    );
  }
}
